module.exports = __webpack_public_path__ + "img/p2.540ace4c.png";